import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { request } from "../../../utils/api";
import { AuthContext } from "../../../auth/AuthContext";

const Cost = () => {
  const { user } = useContext(AuthContext);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [shipmentCost, setShipmentCost] = useState("");
  const [loading, setLoading] = useState(false);

  const isAdmin = user?.role_key === "admin";
  const isSuperAdmin = user?.role_key === "super_admin";

  const getProductWarehouse = async () => {
    try {
      const response = await request({ url: "warehouses", method: "GET" });
      setWarehouses(
        response.data.items.map((item) => ({
          warehouse_name: item.name,
          id: item.id,
        }))
      );
    } catch (error) {
      toast.error("Error fetching warehouses");
    }
  };

  useEffect(() => {
    getProductWarehouse();
  }, []);

  const handleWarehouseChange = (value) => {
    setSelectedWarehouse(value);
    setShipmentCost("");
  };

  const handleSave = async () => {
    if (!selectedWarehouse) return toast.error("Please select a warehouse");
    if (!shipmentCost || isNaN(shipmentCost) || Number(shipmentCost) <= 0)
      return toast.error("Enter a valid shipment cost");
    const formData = new FormData();
    formData.append("id", selectedWarehouse);
    formData.append("shipment_cost", Number(shipmentCost));
    try {
      setLoading(true);
      await request({
        url: 'shipment_cost',
        method: "POST",
        data: formData,
      });
      toast.success("Shipment cost saved successfully");
      setShipmentCost("");
      setSelectedWarehouse("");
    } catch (error) {
      toast.error("Failed to save shipment cost");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="page-toolbar py-3">
          <ol className="breadcrumb bg-transparent mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">Calculation</li>
            <li className="breadcrumb-item active">Warehouse Shipment cost</li>
          </ol>
        </div>

        <div className="card shadow-sm">
          <div className="card-header">
            <h6 className="m-0">Warehouse Shipment cost</h6>
          </div>

          {(isSuperAdmin || isAdmin) && (
            <div className="card mx-3 my-3 p-3">
              <div className="mb-3">
                <label className="form-label">Select Warehouse</label>
                <select
                  name="warehouse_id"
                  className="form-select border-start-0 focus-effect"
                  value={selectedWarehouse}
                  onChange={(e) => handleWarehouseChange(e.target.value)}
                >
                  <option value="">Select Warehouse</option>
                  {warehouses.map((wh) => (
                    <option key={wh.id} value={wh.id}>
                      {wh.warehouse_name}
                    </option>
                  ))}
                </select>
              </div>

              {selectedWarehouse && (
                <div className="mb-3">
                  <label className="form-label">Shipment Cost</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter shipment cost"
                    value={shipmentCost}
                    onChange={(e) => setShipmentCost(e.target.value)}
                  />
                </div>
              )}

              {selectedWarehouse && (
                <div className="text-end">
      <button
        className="btn btn-primary btn-sm"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </button>
    </div>
              )}
            </div>
          )}

          <div className="card-body">{/* Other content if needed */}</div>
        </div>
      </div>
    </>
  );
};

export default Cost;
